import { FC, PropsWithChildren } from 'react';

interface Props {
	disabled: boolean;
}

export const DisabledInteractionFieldset: FC<PropsWithChildren<Props>> = ({
	disabled,
	children,
}) => {
	return (
		<fieldset
			disabled={disabled}
			style={{ border: 0, margin: 0, padding: 0 }}
		>
			{children}
		</fieldset>
	);
};
